/*
 * @Description: 网货发票 store
 * @Author: lijinpeng
 * @Date: 2022-10-22 10:18:58
 * @LastEditTime: 2023-10-30 16:40:51
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getProjectListByBid } from '@/api/project';
import { getRouteListByBid } from '@/api/routeInfo';
import {
  postNetGoodsInvoiceList,
  getNetGoodsInvoiceStatistics,
  netGoodsInvoiceExportUrl,
} from '@/api/invoice';
import { findChannelInfoByCorp } from '@/api/common';

const storeModuleName = 'netGoodsInvoiceModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'driverInfos',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNos',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'date-picker',
      param: 'invoicingTime',
      value: [],
      valueType: 'date',
      label: '开票时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['invoicingStartTime', 'invoicingEndTime'],
    },
    {
      style: 'date-picker',
      param: 'invoiceApplyTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['invoiceApplyStartTime', 'invoiceApplyEndTime'],
    },
    {
      style: 'input',
      param: 'invoiceApplyName',
      value: '',
      valueType: 'string',
      label: '申请人',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'input',
      param: 'invoiceNo',
      value: '',
      valueType: 'string',
      label: '发票编号',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'select',
      param: 'channelInfoId',
      value: [],
      valueType: 'array',
      state: 'channelInfos',
      label: '承运网货',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'invoiceAbleTime',
      value: [],
      valueType: 'date',
      label: '可开票时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['invoiceAbleStartTime', 'invoiceAbleEndTime'],
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'select',
      param: 'refused',
      value: [],
      valueType: 'array',
      state: 'auditStatusInfos',
      label: '审核状态',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'casccader',
      value: [],
      param: 'unloadingAdministrativeCode',
      label: '卸货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['sendProvince', 'sendCity', 'sendDistrict'],
    },
    {
      style: 'input',
      param: 'unloadingAddress',
      value: '',
      valueType: 'string',
      label: '详细地址',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'input',
      param: 'goodsName',
      value: '',
      valueType: 'string',
      label: '货物名称',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '开票状态',
      name: 'invoicingStatus',
      value: ['TO_BE_INVOICED'],
      selectList: [
        {
          value: 'ALL',
          label: '全部',
          isActive: false,
          disabled: true,
          count: 0,
        },
        {
          value: 'TO_BE_INVOICED',
          label: '待开票',
          isActive: false,
          count: 0,
        },
        {
          value: 'APPLY_FOR',
          label: '已申请',
          isActive: false,
          count: 0,
        },
        {
          value: 'INVOICING',
          label: '开票中',
          isActive: false,
          count: 0,
        },
        {
          value: 'INVOICED',
          label: '已开票',
          isActive: false,
          count: 0,
        },
      ],
    },
  ],
  isExport: {
    isShow: true,
    method: 'post',
    url: netGoodsInvoiceExportUrl,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单信息',
        prop: 'waybillInfo',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-waybillInfo',
      },
      {
        label: '开票状态',
        prop: 'invoicingStatusDescription',
        width: 80,
        checked: 1,
        sortable: true,
      },
      {
        label: '开票金额（元）',
        prop: 'invoiceAmount',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-invoiceAmount',
      },
      {
        label: '运力信息',
        prop: 'capacityInfo',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-capacityInfo',
      },
      {
        label: '发票信息',
        prop: 'invoiceInfo',
        width: 230,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-invoiceInfo',
      },
      {
        label: '系统时间',
        prop: 'systemTime',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-systemTime',
      },
      {
        label: '可开票时间',
        prop: 'invoiceAbleTime',
        width: 200,
        checked: 1,
        sortable: true,
      },
      {
        label: '邮寄信息',
        prop: 'mailInfos',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-mailInfos',
      },
      {
        label: '开票信息',
        prop: 'invoicingInfo',
        width: 220,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-invoicingInfo',
      },
      {
        label: '备注',
        prop: 'rejectMessage',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-rejectMessage',
      },
    ],
  },
  auditStatusInfos: [
    {
      label: '全部',
      value: 'ALL',
    },
    {
      label: '已拒绝',
      value: 'REFUSED',
    },
  ],
  invoicingStatus: [], // 支付状态统计
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  channelInfos: [], // 网络货运平台列表
  routeList: [], // 线路列表
  projectList: [], // 项目列表
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    // 获取统计信息
    context.dispatch('getStatistics');
    var netGoodListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      netGoodListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.projectId) {
      netGoodListHabits.projectId = obj.projectId;
    }
    if (obj.routeInfoId) {
      netGoodListHabits.routeInfoId = obj.routeInfoId;
    }
    localStorage.setItem('netGoodListHabits', JSON.stringify(netGoodListHabits));
    const { data } = await postNetGoodsInvoiceList(
      Object.assign({}, params, context.state.postParams),
    );
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await getNetGoodsInvoiceStatistics({
      businessId: context.state.parameters[0].value,
    });
    context.commit('updateState', {
      key: 'invoicingStatus',
      value: data,
    });
    data.forEach(item => {
      const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
        return selectItem.value === item.type;
      });
      context.commit('updateButtonValueFromIndex', {
        index,
        value: item.count,
      });
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        context.commit('updateState', {
          key: 'projectList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const params = {
        businessId: context.state.parameters[0].value,
        projectId: context.state.postParams.projectId,
        lineType: 'transfer',
        keyword,
      };
      const { code, data } = await getRouteListByBid(params);
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取网货列表
  getChannelList: async context => {
    const { code, data } = await findChannelInfoByCorp({
      businessId: context.state.parameters[0].value,
    });
    if (code === 200) {
      const list = data.list.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      context.commit('updateState', {
        key: 'channelInfos',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.value = ['TO_BE_INVOICED'];
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('netGoodListHabits');
          localStorage.setItem(
            'netGoodListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        state.projectInfo = state.projectList.find(item => item.id === payload.id);
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      default:
        break;
    }
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    // 选中的按钮
    let selectValue = '';
    specialData.selectList.forEach(item => {
      item.isActive = false;
      if (item.value === payload.value) {
        item.isActive = true;
        if (payload.value !== 'ALL') selectValue = [item.value];
      }
    });
    // 选中的值
    specialData.value = selectValue;
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
